/**
 * Formats a currency amount for display using Intl.NumberFormat.
 *
 * @param amount - The currency amount. By default treated as a major unit (e.g. dollars).
 *   Set `fromSmallestUnit: true` for Stripe-style smallest-unit values (e.g. cents).
 * @param currency - ISO 4217 currency code (e.g., "usd", "eur")
 * @param options - Optional formatting options
 * @returns Formatted currency string (e.g., "$29.99")
 */
export function formatCurrency(
  amount: number,
  currency: string,
  options?: {
    locale?: string;
    fromSmallestUnit?: boolean; // Default: false. Set true to divide by 100 (e.g. Stripe cents)
  }
): string {
  const { locale, fromSmallestUnit = false } = options ?? {};
  const displayAmount = fromSmallestUnit ? amount / 100 : amount;
  // Default to USD if currency is empty or undefined
  const currencyCode = currency || "USD";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  }).format(displayAmount);
}
